import { render, staticRenderFns } from "./userdescription-component.vue?vue&type=template&id=0bc509cc"
import script from "./userdescription-component.vue?vue&type=script&lang=ts"
export * from "./userdescription-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports